import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VisitasService } from './visitas.service';
import { JsonReturn } from '../shared/interface/generic-interface';
import { NgFor, NgIf } from '@angular/common';
import { InfoRoteiroVisitaComponent } from './info-roteiro-visita/info-roteiro-visita.component';
import { InfoEntregasVisitaComponent } from './info-entregas-visita/info-entregas-visita.component';
import { StatusClienteVisitaComponent } from './status-cliente-visita/status-cliente-visita.component';
import { BoxInfoAlertService } from '../box-info-alert/box-info-alert.service';
import { PopupMsgOcComponent } from '../popup-msg-oc/popup-msg-oc.component';

@Component({
    selector: 'app-visitas',
    templateUrl: './visitas.component.html',
    styleUrls: ['./visitas.component.css'],
    standalone: true,
    imports: [NgFor, InfoRoteiroVisitaComponent, InfoEntregasVisitaComponent, StatusClienteVisitaComponent, NgIf, PopupMsgOcComponent]
})
export class VisitasComponent{
  @Input() dashboardResult = [];  
  @Input() filtroVisitaAtivoIDs: Array<number> = [];  
  @Output() abrirModalMapa = new EventEmitter<number>();  
  dadosVisitas = [];
  constructor(private visitasService: VisitasService, public boxInfoAlertService: BoxInfoAlertService){}
  
  ngOnChanges(): void {
    this.getVisitas()
  }

  abrirRoteiro(roteiro){
    this.abrirModalMapa.emit(roteiro.NumeroRoteiro);
  }

  async getVisitas(){
    let strRoteiros = this.dashboardResult.map((roteiro) => roteiro.NumeroRoteiro).join(',');  
    if(strRoteiros){
      let response: JsonReturn =  await this.visitasService.getVisitas(strRoteiros)
      this.dadosVisitas = response.response;
      await this.boxInfoAlertService.getInfoAlertRouterRoteiro(strRoteiros);
    }
  }
}
